import {
  Companion_instance9nc3ckjwxlpc as Companion_instance,
  AlwaysSharedCopyTracker_getInstance98x6x1x3dodo as AlwaysSharedCopyTracker_getInstance,
} from './Segment.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SegmentPoolClass;
function SegmentPool() {
  if (SegmentPoolClass === VOID) {
    class $ {
      constructor() {
        this.m4j_1 = 0;
        this.n4j_1 = 0;
      }
      l3w() {
        return Companion_instance.q4k();
      }
      d4k(segment) {
      }
      u4k() {
        return AlwaysSharedCopyTracker_getInstance();
      }
    }
    initMetadataForObject($, 'SegmentPool');
    SegmentPoolClass = $;
  }
  return SegmentPoolClass;
}
var SegmentPool_instance;
function SegmentPool_getInstance() {
  return SegmentPool_instance;
}
//region block: init
SegmentPool_instance = new (SegmentPool())();
//endregion
//region block: exports
export {
  SegmentPool_instance as SegmentPool_instance1wzn9b23peown,
};
//endregion

//# sourceMappingURL=SegmentPool.mjs.map
